import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ADVISOR_IMAGE, ADVISOR_NAME } from '../../../../../../constants/selectors';
import styles from './styles.module.css';

export function ProfileHeader() {
  const { t } = useTranslation();
  const advisorInfo = useMemo(() => {
    return (
      <>
        <div className={clsx(styles.advisorDescription, 'font-openSans')}>{t('profile.header.cost')}</div>
      </>
    );
  }, [t]);
  const advisorName = useMemo(() => {
    return t('REACT_BOOKING_FRONTEND.booking2.book') + ' ' + document.querySelector(ADVISOR_NAME)?.textContent || '';
  }, [t]);

  const imgSrc = useMemo(() => {
    const elem = document.querySelector(ADVISOR_IMAGE);

    return elem?.getAttribute('src') || '';
  }, []);

  return (
    <div className={clsx(styles.headerWrapper, 'modal-header')}>
      <div className="flex flex-col p-4 sm:flex-row sm:p-10">
        <div className="flex mb-3 items-center sm:items-start sm:mb-0">
          <div className="flex-auto mr-4 sm:mr-7">
            <img className={clsx('rounded-full object-contain', styles.avatar)} alt="" src={imgSrc} />
          </div>
          <div className="flex-auto">
            <div className={clsx(styles.advisorName, 'mb-3 font-libreBaskerville')}>{advisorName}</div>
            <div className="hidden sm:block">{advisorInfo}</div>
          </div>
        </div>
        <div className="block sm:hidden">{advisorInfo}</div>
      </div>
    </div>
  );
}
